<template lang="pug">
v-container
  div.text-lg.font-medium.basic700--text {{ $t('appt_date_selection_preference') }}
  div.text-sm.font-normal.basic600--text {{ $t('appt_date_selection_preference_desc') }}

  div.d-flex.justify-center.my-10(v-if="isFetching")
    v-progress-circular(:width="2" :size="50" color="primary" indeterminate)

  v-row(v-else)
    v-col(cols="12" sm="7")
      v-radio-group(v-model="datePickerView" hide-details)
        div.d-flex.align-center
          v-radio.mb-0(value="calendar" color="basic700" )
          div.text-md.font-normal.basic700--text(@click="datePickerView = 'calendar'") {{ $t('show_calendar_first') }}
          v-spacer
          v-btn.button-xs(color="neutral700" outlined depressed @click="goToPreview('calendar')" :loading="isLoadingPreview") {{ $t('preview') }}
        div.d-flex.align-center.mt-2
          v-radio.mb-0(value="sheet" color="basic700" )
          div.text-md.font-normal.basic700--text(@click="datePickerView = 'sheet'") {{ $t('show_provider_availability') }}
          v-spacer
          v-btn.button-xs(color="neutral700" outlined depressed @click="goToPreview('sheet')" :loading="isLoadingPreview") {{ $t('preview') }}

  div.d-flex.mt-5
    v-spacer
    v-btn.button-md(color="neutral700" dark depressed :loading="isLoading" @click="saveData") {{ $t('save') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import EmbedDialog from '@/components/donation/dialogs/EmbedDialog.vue'

export default {
  name: 'GeneralDatePicker',
  components: { EmbedDialog },
  data () {
    return {
      isFetching: false,
      isLoading: false,
      isLoadingPreview: false,
      datePickerView: null,
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      form: 'clinic/getForm'
    }),
  },
  mounted () {
    this.fetchPickerView()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchPickerView () {
      this.isFetching = true
      this.$axios.get(`/clinics/${this.company.slug}`)
        .then(resp => {
          this.datePickerView = resp.data.show_calendar ? 'calendar' : 'sheet'
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    saveData () {
      this.isLoading = true
      const data = {
        show_calendar: Boolean(this.datePickerView === 'calendar')
      }
      this.$axios.patch(`/clinics/${this.company.slug}`, data)
        .then(() => {
          this.showMessage(['success', this.$t('success_message.successfully_updated')])
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    goToPreview (view) {
      this.isLoadingPreview = true
      this.$axios.get(`/clinics/${this.company.slug}/services?status=published&booking_enabled=true`)
        .then(resp => {
          if (resp.data.results && resp.data.results.length > 0) {
            let link = `https://${this.company.slug}.yezza.co/appointment/preview-${resp.data.results[0].id}?date=${view}`
            window.open(link, '_blank')
          } else {
            this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoadingPreview = false
        })
    }
  }

}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-basic500);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>